<a class="banner" href="/" (click)="didClickBanner($event)">
  <ax-icon class="icon" name="eye-off-outline"></ax-icon>
  <span>{{ 'preview.private' | translate }}</span>
  <button axButton color="white" icon-button (click)="didClickClose($event)">
    <ax-icon class="icon" name="close"></ax-icon>
  </button>
</a>
